import { render, staticRenderFns } from "./ChatScreen.vue?vue&type=template&id=e47e892e&scoped=true&"
import script from "./ChatScreen.vue?vue&type=script&lang=js&"
export * from "./ChatScreen.vue?vue&type=script&lang=js&"
import style0 from "./ChatScreen.vue?vue&type=style&index=0&id=e47e892e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47e892e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e47e892e')) {
      api.createRecord('e47e892e', component.options)
    } else {
      api.reload('e47e892e', component.options)
    }
    module.hot.accept("./ChatScreen.vue?vue&type=template&id=e47e892e&scoped=true&", function () {
      api.rerender('e47e892e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/support/screens/SupportScreen/ChatScreen.vue"
export default component.exports